module.exports = __webpack_public_path__ + "static/media/S (71).eaaa6093.jpg";